import React, { useMemo, FC } from 'react';
import EventsUS from './EventsUS';
import EventsDE from './EventsDE';
import { useAuthContext } from '@/contexts';

const Events: FC = () => {
  const { profile } = useAuthContext();

  const Page = useMemo(() => {
    if (profile?.market === 'DE') {
      return EventsDE;
    }
    return EventsUS;
  }, [profile?.market]);

  return <Page />;
};

export default Events;
